import React, { useState, useEffect } from 'react'
import { Link, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { usePermissions } from '../contexts/PermissionsContext'
import { messagingApi } from '../services/api'

// Icon Components
const HomeIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
    <polyline points="9 22 9 12 15 12 15 22"/>
  </svg>
)

const CRMIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
  </svg>
)

const LeadsIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <line x1="19" y1="8" x2="19" y2="14"/>
    <line x1="22" y1="11" x2="16" y2="11"/>
  </svg>
)

const DealsIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="5" height="18" rx="1"/>
    <rect x="10" y="3" width="5" height="12" rx="1"/>
    <rect x="17" y="3" width="5" height="8" rx="1"/>
  </svg>
)

const ContactsIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
    <circle cx="12" cy="7" r="4"/>
  </svg>
)

const ActivitiesIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
    <polyline points="22 4 12 14.01 9 11.01"/>
  </svg>
)

const CommunicationIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
  </svg>
)

const MessageIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/>
  </svg>
)

const TemplateIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2"/>
    <line x1="3" y1="9" x2="21" y2="9"/>
    <line x1="9" y1="21" x2="9" y2="9"/>
  </svg>
)


const WorkflowIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="6" height="6" rx="1"/>
    <rect x="15" y="3" width="6" height="6" rx="1"/>
    <rect x="9" y="15" width="6" height="6" rx="1"/>
    <path d="M6 9v3a1 1 0 0 0 1 1h4"/>
    <path d="M18 9v3a1 1 0 0 1-1 1h-4"/>
  </svg>
)

const ReportsIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 21H4.6A.6.6 0 0 1 4 20.4V3"/>
    <path d="m4 15 4-4 4 4 8-8"/>
  </svg>
)

const AnalyticsIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 21H4.6A.6.6 0 0 1 4 20.4V3"/>
    <path d="m4 15 4-4 4 4 8-8"/>
    <path d="M16 7h4v4"/>
  </svg>
)

const ReportIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
    <polyline points="14 2 14 8 20 8"/>
    <line x1="16" y1="13" x2="8" y2="13"/>
    <line x1="16" y1="17" x2="8" y2="17"/>
  </svg>
)

const ChartIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="20" x2="18" y2="10"/>
    <line x1="12" y1="20" x2="12" y2="4"/>
    <line x1="6" y1="20" x2="6" y2="14"/>
  </svg>
)


const RobotIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="11" width="18" height="10" rx="2"/>
    <circle cx="12" cy="5" r="2"/>
    <path d="M12 7v4"/>
    <line x1="8" y1="16" x2="8" y2="16"/>
    <line x1="16" y1="16" x2="16" y2="16"/>
    <path d="M9 16h.01"/>
    <path d="M15 16h.01"/>
  </svg>
)

const BillingIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="1" y="4" width="22" height="16" rx="2" ry="2"/>
    <line x1="1" y1="10" x2="23" y2="10"/>
  </svg>
)

const SettingsIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="3"/>
    <path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/>
  </svg>
)




// Types
interface NavItemProps {
  to: string
  icon: React.ReactNode
  label: string
  isActive: boolean
  isCollapsed: boolean
  badge?: number
}

interface NavSectionProps {
  title: string
  icon: React.ReactNode
  items: { to: string; icon: React.ReactNode; label: string; badge?: number }[]
  isCollapsed: boolean
  isActive: (path: string) => boolean
  defaultOpen?: boolean
  isOpen?: boolean
  onToggle?: () => void
}

// Single Nav Item Component
const NavItem: React.FC<NavItemProps> = ({ to, icon, label, isActive, isCollapsed, badge }) => (
  <Link
    to={to}
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: 'var(--space-3)',
      padding: isCollapsed ? 'var(--space-2-5)' : 'var(--space-2-5) var(--space-4)',
      marginLeft: isCollapsed ? 0 : 'var(--space-3)',
      borderRadius: 'var(--radius-lg)',
      color: isActive ? 'var(--color-primary-600)' : 'var(--text-secondary)',
      background: isActive ? 'var(--color-primary-50)' : 'transparent',
      textDecoration: 'none',
      transition: 'all var(--transition-fast)',
      justifyContent: isCollapsed ? 'center' : 'flex-start',
      position: 'relative',
    }}
    className="nav-item"
  >
    {isActive && !isCollapsed && (
      <div style={{
        position: 'absolute',
        left: '-12px',
        top: '50%',
        transform: 'translateY(-50%)',
        width: '3px',
        height: '20px',
        background: 'var(--bg-gradient)',
        borderRadius: 'var(--radius-full)',
      }} />
    )}
    <span style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '20px',
      height: '20px',
      flexShrink: 0,
      opacity: isActive ? 1 : 0.7,
    }}>
      {icon}
    </span>
    {!isCollapsed && (
      <>
        <span style={{
          fontSize: 'var(--text-sm)',
          fontWeight: isActive ? 'var(--font-weight-medium)' : 'var(--font-weight-regular)',
          flex: 1,
        }}>
          {label}
        </span>
        {badge && badge > 0 && (
          <span style={{
            background: 'var(--color-error-500)',
            color: 'white',
            fontSize: '10px',
            fontWeight: 'var(--font-weight-semibold)',
            padding: '2px 6px',
            borderRadius: 'var(--radius-full)',
            minWidth: '18px',
            textAlign: 'center',
          }}>
            {badge > 99 ? '99+' : badge}
          </span>
        )}
      </>
    )}
  </Link>
)

// Collapsible Section Component
const NavSection: React.FC<NavSectionProps> = ({
  title,
  icon,
  items,
  isCollapsed,
  isActive,
  defaultOpen = false,
  isOpen: externalIsOpen,
  onToggle
}) => {
  const location = useLocation()
  const hasActiveChild = items.some(item => isActive(item.to))
  const [internalIsOpen, setInternalIsOpen] = useState(defaultOpen || hasActiveChild)

  // Use external state if provided, otherwise use internal state
  const isOpen = externalIsOpen !== undefined ? externalIsOpen : internalIsOpen
  const handleToggle = onToggle || (() => setInternalIsOpen(!internalIsOpen))

  // Auto-expand when a child becomes active (only for internal state)
  useEffect(() => {
    if (hasActiveChild && !isOpen && externalIsOpen === undefined) {
      setInternalIsOpen(true)
    }
    // When using external state, call onToggle to open
    if (hasActiveChild && !isOpen && onToggle) {
      onToggle()
    }
  }, [location.pathname, hasActiveChild])

  if (isCollapsed) {
    // When collapsed, show only icons in a vertical list
    return (
      <div style={{ marginBottom: 'var(--space-2)' }}>
        {items.map((item) => (
          <NavItem
            key={item.to}
            to={item.to}
            icon={item.icon}
            label={item.label}
            isActive={isActive(item.to)}
            isCollapsed={true}
            badge={item.badge}
          />
        ))}
      </div>
    )
  }

  return (
    <div style={{ marginBottom: 'var(--space-2)' }}>
      {/* Section Header - Clickable */}
      <button
        onClick={handleToggle}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 'var(--space-3)',
          width: '100%',
          padding: 'var(--space-3) var(--space-4)',
          borderRadius: 'var(--radius-lg)',
          border: 'none',
          background: hasActiveChild ? 'var(--glass-bg-subtle)' : 'transparent',
          cursor: 'pointer',
          transition: 'all var(--transition-fast)',
          color: hasActiveChild ? 'var(--text-primary)' : 'var(--text-secondary)',
        }}
        className="nav-section-header"
      >
        <span style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '22px',
          height: '22px',
          color: hasActiveChild ? 'var(--color-primary-600)' : 'inherit',
        }}>
          {icon}
        </span>
        <span style={{
          fontSize: 'var(--text-sm)',
          fontWeight: 'var(--font-weight-medium)',
          flex: 1,
          textAlign: 'left',
        }}>
          {title}
        </span>
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          style={{
            transition: 'transform var(--transition-fast)',
            transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            opacity: 0.5,
          }}
        >
          <path d="m6 9 6 6 6-6"/>
        </svg>
      </button>

      {/* Section Items - Animated */}
      <div
        style={{
          overflow: 'hidden',
          transition: 'all var(--transition-base)',
          maxHeight: isOpen ? `${items.length * 44}px` : '0px',
          opacity: isOpen ? 1 : 0,
        }}
      >
        <div style={{
          paddingTop: 'var(--space-1)',
          display: 'flex',
          flexDirection: 'column',
          gap: 'var(--space-0-5)',
        }}>
          {items.map((item) => (
            <NavItem
              key={item.to}
              to={item.to}
              icon={item.icon}
              label={item.label}
              isActive={isActive(item.to)}
              isCollapsed={false}
              badge={item.badge}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

const Layout = () => {
  const { user, logout, isAuthenticated } = useAuth()
  const { hasPermission, isAdmin, isManager } = usePermissions()
  const location = useLocation()
  const [isCollapsed, setIsCollapsed] = useState(false)
  const [openSection, setOpenSection] = useState<string | null>(null)
  const [unreadCount, setUnreadCount] = useState(0)

  // Buscar contador de mensagens não lidas
  useEffect(() => {
    const fetchUnreadCount = async () => {
      try {
        const data = await messagingApi.getUnreadCount()
        setUnreadCount(data.unread_count)
      } catch (error) {
        console.error('Erro ao buscar unread count:', error)
      }
    }
    
    // Buscar ao montar
    fetchUnreadCount()
    
    // Atualizar a cada 30 segundos
    const interval = setInterval(fetchUnreadCount, 30000)
    
    return () => clearInterval(interval)
  }, [])

  // Auto-open section containing active route
  useEffect(() => {
    const navStructure = [
      { title: 'CRM', items: ['/deals', '/leads'] },
      { title: 'Conversas', items: ['/messaging', '/contacts'] },
      { title: 'Relatórios', items: ['/analytics', '/reports', '/performance'] },
    ]

    const activeSection = navStructure.find(section =>
      section.items.some(item => location.pathname.startsWith(item))
    )

    if (activeSection && openSection !== activeSection.title) {
      setOpenSection(activeSection.title)
    }
  }, [location.pathname])

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/'
    return location.pathname.startsWith(path)
  }

  if (!isAuthenticated) {
    return <Outlet />
  }

  const sidebarWidth = isCollapsed ? '72px' : '260px'

  // Acessos Rápidos - visível para todos
  const quickAccessItems = [
    { to: '/', icon: <HomeIcon />, label: 'Início', permission: 'deals' },
    { to: '/deals', icon: <DealsIcon />, label: 'Negociações', permission: 'deals' },
    { to: '/messaging', icon: <MessageIcon />, label: 'Conversas', badge: unreadCount, permission: 'messaging' },
    { to: '/activities', icon: <ActivitiesIcon />, label: 'Tarefas', permission: 'activities' },
  ].filter(item => isAdmin || hasPermission(item.permission))

  // Links únicos - apenas admin/manager
  const singleAccessItems = [
    { to: '/ai-agents', icon: <RobotIcon />, label: 'Agentes de IA', permission: 'ai-agents' },
    { to: '/automations', icon: <WorkflowIcon />, label: 'Workflows', permission: 'automations' },
    { to: '/templates', icon: <TemplateIcon />, label: 'Templates', permission: 'templates' },
  ].filter(item => (isAdmin || isManager) && hasPermission(item.permission))

  return (
    <div className="flex" style={{ height: '100vh', overflow: 'hidden', background: 'var(--bg-secondary)' }}>
      {/* Background decorative elements */}
      <div style={{
        position: 'fixed',
        top: '-20%',
        right: '-10%',
        width: '600px',
        height: '600px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(99, 102, 241, 0.06) 0%, transparent 70%)',
        pointerEvents: 'none',
        zIndex: 0,
      }} />
      <div style={{
        position: 'fixed',
        bottom: '-30%',
        left: '-15%',
        width: '800px',
        height: '800px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(139, 92, 246, 0.04) 0%, transparent 70%)',
        pointerEvents: 'none',
        zIndex: 0,
      }} />

      {/* Sidebar */}
      <aside style={{
        width: sidebarWidth,
        background: 'var(--bg-primary)',
        borderRight: '1px solid var(--border-light)',
        display: 'flex',
        flexDirection: 'column',
        position: 'fixed',
        height: '100vh',
        zIndex: 20,
        transition: 'width var(--transition-base)',
      }}>
        {/* Logo Section */}
        <div style={{
          padding: isCollapsed ? 'var(--space-4)' : 'var(--space-5) var(--space-5)',
          borderBottom: '1px solid var(--border-light)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: isCollapsed ? 'center' : 'space-between',
          minHeight: '72px',
        }}>
          <Link
            to="/"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 'var(--space-3)',
              textDecoration: 'none',
            }}
          >
            {isCollapsed ? (
              <img
                src="/icon.png"
                alt="FLIPR"
                style={{
                  height: '36px',
                  width: '36px',
                  objectFit: 'contain',
                }}
              />
            ) : (
              <img
                src="/logo-black.png"
                alt="FLIPR CRM"
                style={{
                  height: '48px',
                }}
              />
            )}
          </Link>
          {!isCollapsed && (
            <button
              onClick={() => setIsCollapsed(true)}
              style={{
                background: 'var(--bg-tertiary)',
                border: 'none',
                padding: 'var(--space-1-5)',
                borderRadius: 'var(--radius-md)',
                cursor: 'pointer',
                color: 'var(--text-tertiary)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all var(--transition-fast)',
              }}
              className="collapse-btn"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M11 17l-5-5 5-5"/>
                <path d="M18 17l-5-5 5-5"/>
              </svg>
            </button>
          )}
        </div>

        {/* Expand button when collapsed */}
        {isCollapsed && (
          <button
            onClick={() => setIsCollapsed(false)}
            style={{
              background: 'var(--bg-tertiary)',
              border: 'none',
              padding: 'var(--space-2)',
              margin: 'var(--space-3) auto',
              borderRadius: 'var(--radius-md)',
              cursor: 'pointer',
              color: 'var(--text-tertiary)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all var(--transition-fast)',
            }}
            className="expand-btn"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M13 7l5 5-5 5"/>
              <path d="M6 7l5 5-5 5"/>
            </svg>
          </button>
        )}

        {/* Navigation */}
        <nav style={{
          padding: isCollapsed ? 'var(--space-3)' : 'var(--space-4)',
          flex: 1,
          overflowY: 'auto',
          overflowX: 'hidden',
        }}>
          {/* Acessos Rápidos */}
          {!isCollapsed && (
            <p style={{
              fontSize: '10px',
              fontWeight: 'var(--font-weight-semibold)',
              color: 'var(--text-tertiary)',
              textTransform: 'uppercase',
              letterSpacing: '0.1em',
              marginBottom: 'var(--space-3)',
              paddingLeft: 'var(--space-4)',
            }}>
              Acessos Rápidos
            </p>
          )}

          {quickAccessItems.map((item) => (
            <NavItem
              key={item.to}
              to={item.to}
              icon={item.icon}
              label={item.label}
              isActive={isActive(item.to)}
              isCollapsed={isCollapsed}
              badge={item.badge}
            />
          ))}

          {/* Separador */}
          <div style={{
            height: '1px',
            background: 'var(--border-light)',
            margin: 'var(--space-3) var(--space-4)',
          }} />

          {/* Dropdown CRM */}
          {(isAdmin || hasPermission('deals') || hasPermission('leads')) && (
            <NavSection
              title="CRM"
              icon={<CRMIcon />}
              items={[
                { to: '/deals', icon: <DealsIcon />, label: 'Negociações' },
                { to: '/leads', icon: <LeadsIcon />, label: 'Leads' },
              ].filter(item => isAdmin || hasPermission(item.to.replace('/', '')))}
              isCollapsed={isCollapsed}
              isActive={isActive}
              isOpen={openSection === 'CRM'}
              onToggle={() => setOpenSection(openSection === 'CRM' ? null : 'CRM')}
            />
          )}

          {/* Dropdown Conversas */}
          {(isAdmin || hasPermission('messaging') || hasPermission('contacts')) && (
            <NavSection
              title="Conversas"
              icon={<CommunicationIcon />}
              items={[
                { to: '/messaging', icon: <MessageIcon />, label: 'Mensagens' },
                { to: '/contacts', icon: <ContactsIcon />, label: 'Contatos' },
              ].filter(item => isAdmin || hasPermission(item.to.replace('/', '')))}
              isCollapsed={isCollapsed}
              isActive={isActive}
              isOpen={openSection === 'Conversas'}
              onToggle={() => setOpenSection(openSection === 'Conversas' ? null : 'Conversas')}
            />
          )}

          {/* Dropdown Relatórios - apenas admin/manager */}
          {(isAdmin || isManager) && (isAdmin || hasPermission('analytics') || hasPermission('reports') || hasPermission('performance')) && (
            <NavSection
              title="Relatórios"
              icon={<ReportsIcon />}
              items={[
                { to: '/analytics', icon: <AnalyticsIcon />, label: 'Analytics' },
                { to: '/performance', icon: <ChartIcon />, label: 'Performance' },
                { to: '/reports', icon: <ReportIcon />, label: 'Relatórios' },
              ].filter(item => isAdmin || hasPermission(item.to.replace('/', '')))}
              isCollapsed={isCollapsed}
              isActive={isActive}
              isOpen={openSection === 'Relatórios'}
              onToggle={() => setOpenSection(openSection === 'Relatórios' ? null : 'Relatórios')}
            />
          )}

          {/* Links únicos - apenas admin/manager */}
          {singleAccessItems.length > 0 && (
            <>
              <div style={{
                height: '1px',
                background: 'var(--border-light)',
                margin: 'var(--space-3) var(--space-4)',
              }} />
              {!isCollapsed && (
                <p style={{
                  fontSize: '10px',
                  fontWeight: 'var(--font-weight-semibold)',
                  color: 'var(--text-tertiary)',
                  textTransform: 'uppercase',
                  letterSpacing: '0.1em',
                  marginBottom: 'var(--space-3)',
                  paddingLeft: 'var(--space-4)',
                }}>
                  Ferramentas
                </p>
              )}
              {singleAccessItems.map((item) => (
                <NavItem
                  key={item.to}
                  to={item.to}
                  icon={item.icon}
                  label={item.label}
                  isActive={isActive(item.to)}
                  isCollapsed={isCollapsed}
                />
              ))}
            </>
          )}
        </nav>

        {/* Bottom Section - Settings & User */}
        <div style={{
          padding: isCollapsed ? 'var(--space-3)' : 'var(--space-4)',
          borderTop: '1px solid var(--border-light)',
        }}>
          {/* Configurações - Apenas admin */}
          {isAdmin && (
            <Link
              to="/settings"
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 'var(--space-3)',
                padding: isCollapsed ? 'var(--space-2-5)' : 'var(--space-2-5) var(--space-4)',
                borderRadius: 'var(--radius-lg)',
                color: (isActive('/settings') || isActive('/billing') || isActive('/integrations') || isActive('/company-users') || isActive('/teams') || isActive('/webhooks') || isActive('/outgoing-webhooks') || isActive('/custom-fields') || isActive('/lead-distribution'))
                  ? 'var(--color-primary-600)' : 'var(--text-secondary)',
                background: (isActive('/settings') || isActive('/billing') || isActive('/integrations') || isActive('/company-users') || isActive('/teams') || isActive('/webhooks') || isActive('/outgoing-webhooks') || isActive('/custom-fields') || isActive('/lead-distribution'))
                  ? 'var(--color-primary-50)' : 'transparent',
                textDecoration: 'none',
                transition: 'all var(--transition-fast)',
                justifyContent: isCollapsed ? 'center' : 'flex-start',
                marginBottom: 'var(--space-3)',
              }}
              className="nav-item"
            >
              <SettingsIcon />
              {!isCollapsed && (
                <span style={{ fontSize: 'var(--text-sm)', fontWeight: 'var(--font-weight-medium)' }}>
                  Configurações
                </span>
              )}
            </Link>
          )}

          {/* User Profile */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: 'var(--space-3)',
            padding: isCollapsed ? 'var(--space-2)' : 'var(--space-3)',
            background: 'var(--bg-tertiary)',
            borderRadius: 'var(--radius-lg)',
            justifyContent: isCollapsed ? 'center' : 'flex-start',
          }}>
            <div style={{
              width: '36px',
              height: '36px',
              borderRadius: 'var(--radius-full)',
              background: 'var(--bg-gradient)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontWeight: 'var(--font-weight-semibold)',
              fontSize: 'var(--text-sm)',
              flexShrink: 0,
            }}>
              {user?.first_name?.[0]}{user?.last_name?.[0]}
            </div>
            {!isCollapsed && (
              <>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <p style={{
                    fontSize: 'var(--text-sm)',
                    fontWeight: 'var(--font-weight-medium)',
                    color: 'var(--text-primary)',
                    margin: 0,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}>
                    {user?.first_name} {user?.last_name}
                  </p>
                  <p style={{
                    fontSize: 'var(--text-xs)',
                    color: 'var(--text-tertiary)',
                    margin: 0,
                  }}>
                    {user?.role === 'admin' ? 'Administrador' :
                     user?.role === 'manager' ? 'Gerente' :
                     user?.role === 'agent' ? 'Funcionário' :
                     user?.role === 'viewer' ? 'Visualizador' : user?.role}
                  </p>
                </div>
                <button
                  onClick={logout}
                  style={{
                    background: 'transparent',
                    border: 'none',
                    padding: 'var(--space-1-5)',
                    borderRadius: 'var(--radius-md)',
                    cursor: 'pointer',
                    color: 'var(--text-tertiary)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'all var(--transition-fast)',
                  }}
                  title="Sair"
                  className="logout-btn"
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                    <polyline points="16 17 21 12 16 7"/>
                    <line x1="21" y1="12" x2="9" y2="12"/>
                  </svg>
                </button>
              </>
            )}
          </div>
        </div>
      </aside>

      {/* Main Content */}
      <main style={{
        marginLeft: sidebarWidth,
        flex: 1,
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        transition: 'margin-left var(--transition-base)',
        position: 'relative',
        zIndex: 1,
        overflow: 'auto',
      }}>
        {/* Page Content - Full height without header */}
        <div style={{
          padding: 'var(--space-5)',
          flex: 1,
          minHeight: 0,
        }}>
          <Outlet />
        </div>
      </main>

      {/* Global styles for hover effects */}
      <style>{`
        .nav-item:hover {
          background: var(--bg-tertiary) !important;
          color: var(--text-primary) !important;
        }
        .nav-section-header:hover {
          background: var(--bg-tertiary) !important;
          color: var(--text-primary) !important;
        }
        .collapse-btn:hover, .expand-btn:hover {
          background: var(--border-medium) !important;
          color: var(--text-primary) !important;
        }
        .logout-btn:hover {
          background: var(--border-medium) !important;
          color: var(--color-error-600) !important;
        }
      `}</style>
    </div>
  )
}

export default Layout